declare global {
  type BuildEnvironment =
    | "test"
    | "local"
    | "dev"
    | "uat"
    | "qat"
    | "stress"
    | "staging"
    | "prod"
}

const defaultEnvironment: BuildEnvironment = "dev"

export const buildEnvironment: BuildEnvironment =
  (process.env.REACT_APP_BUILD_ENVIRONMENT as BuildEnvironment) ||
  defaultEnvironment
